var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "px-0": "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "form-section xs12",
          class: [_vm.hasDocModule ? "md4" : "md6"],
          attrs: { "pl-4": "", "pr-3": "", "pl-0": "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "", xs12: "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "primary--text mb-3" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketMandateContractor)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("mandate-quote-selector", {
            attrs: {
              isMandate: _vm.textKey !== "quote_request_text",
              rules: _vm.dtRules.mandateContractorRules,
              block: _vm.currentTicket.fk_ticket_block
            },
            model: {
              value: _vm.fkActorAntity,
              callback: function($$v) {
                _vm.fkActorAntity = $$v
              },
              expression: "fkActorAntity"
            }
          }),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "primary--text mb-3" }, [
                _vm._v(_vm._s(_vm.$t(_vm.secondlabelTranslation)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            staticClass: "white",
            attrs: {
              color: "primary",
              counter: _vm.textConfigs.textarea,
              maxlength: _vm.textConfigs.textarea,
              clearable: _vm.description.length > 0,
              "auto-grow": "",
              solo: ""
            },
            model: {
              value: _vm.description,
              callback: function($$v) {
                _vm.description = $$v
              },
              expression: "description"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section xs12",
          class: [_vm.hasDocModule ? "md4" : "md6"],
          attrs: { "pl-4": "", "pr-3": "", "pl-0": "" }
        },
        [
          _c(
            "v-flex",
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("3")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketMandateAttachment)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            {
              staticClass: "scroll-y",
              staticStyle: { "max-height": "50vh" },
              attrs: { fluid: "", "grid-list-sm": "" }
            },
            [
              _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                _vm.coAttachments.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mandate__reporter mt-1 ml-1 greyDark--text",
                        staticStyle: { "font-family": "Raleway" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.coAttachments.filter(function(x) {
                                return x.checked === true
                              }).length
                            ) +
                            "/" +
                            _vm._s(_vm.coAttachments.length) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                _vm._l(_vm.coAttachments, function(item, index) {
                  return _c("v-flex", { key: index, attrs: { xs4: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "mandate-speaker__image",
                        on: {
                          click: function($event) {
                            _vm.handleChooseAttachment(item)
                          }
                        }
                      },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "mandate-speaker",
                            attrs: {
                              hover: "",
                              color: item.checked ? "secondary" : ""
                            }
                          },
                          [
                            item.attachment.media.type === "image"
                              ? _c("img", {
                                  staticClass: "mandate-speaker__image",
                                  style: { opacity: item.checked ? 0.5 : 1 },
                                  attrs: {
                                    src: item.attachment.media.link,
                                    alt: "item.attachment.media.name"
                                  }
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass: "text-xs-center",
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mt-1 ",
                                        class: item.checked
                                          ? "white--text"
                                          : "primary--text",
                                        attrs: { size: "5vh" }
                                      },
                                      [_vm._v("description\n                ")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "mandate-speaker__image--document my-2 mx-1",
                                      class: item.checked
                                        ? "white--text"
                                        : "primary--text",
                                      domProps: {
                                        textContent: _vm._s(
                                          item.attachment.media.name
                                        )
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasDocModule
        ? _c(
            "v-flex",
            {
              staticClass: "form-section xs12 md4",
              attrs: { "pl-4": "", "pr-3": "", "pl-0": "" }
            },
            [
              _c(
                "v-flex",
                [
                  _c("v-layout", { staticClass: "title--text-custom" }, [
                    _c("div", { staticClass: "primary--text" }, [_vm._v("4")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "primary--text" }, [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.lblSetting.ticketImportDocFromGED))
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                {
                  staticClass: "scroll-y",
                  staticStyle: { "max-height": "50vh" },
                  attrs: { fluid: "", "grid-list-sm": "" }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      placeholder: _vm.$t(_vm.lblSetting.lblFilterPlaceholder),
                      solo: "",
                      "hide-details": ""
                    },
                    on: { input: _vm.searchGEDByKey },
                    model: {
                      value: _vm.dtGEDSearch,
                      callback: function($$v) {
                        _vm.dtGEDSearch = $$v
                      },
                      expression: "dtGEDSearch"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                    _vm.documents.length
                      ? _c(
                          "div",
                          {
                            staticClass: "ml-1 mt-2 greyDark--text",
                            staticStyle: { "font-family": "Raleway" }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.dtSelectedGED.length) +
                                "/" +
                                _vm._s(_vm.dtTotalGED) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    _vm._l(_vm.coDocuments, function(item, index) {
                      return _c(
                        "v-flex",
                        {
                          key: index,
                          attrs: { xs3: "", sm2: "", md4: "", lg3: "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mandate-speaker__image",
                              on: {
                                click: function($event) {
                                  _vm.handleChooseAttachment(item)
                                }
                              }
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "mandate-speaker pa-2",
                                  attrs: {
                                    flat: "",
                                    hover: "",
                                    color: item.checked ? "secondary" : ""
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "mandate-speaker__image",
                                    style: { opacity: item.checked ? 0.5 : 1 },
                                    attrs: {
                                      src: item.icon,
                                      alt: "item.attachment.media.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "mandate-speaker__image--document my-2 mx-1",
                                    class: item.checked
                                      ? "white--text"
                                      : "primary--text",
                                    domProps: { textContent: _vm._s(item.name) }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-247eba3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-247eba3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-modal-mandate-speaker/template.html
// module id = null
// module chunks = 